import {UIWManagerEvents} from './UIWManagerEvents'
import {DiscordInstance} from '../discord/DiscordInstance.ts'
import {SDKRequest} from '../../../../shared/DiscordActivityTypes'
import {SocketLobbySend} from '../../../shared/scripts/socket/SocketLobbySend'
import {Scene} from './UISceneTypes'
import {ColonistMembershipType} from '@colonist/types'

export class UIDManagerEvents extends UIWManagerEvents {
    leaveRoomAndJoinRoom(roomId: string) {
        if(this.uiManager?.sceneController.scene == Scene.Room) this.uiManager?.room.resetRoom()
        void SocketLobbySend.clickedJoinRoom(roomId)
    }

    // eslint-disable-next-line class-methods-use-this
    premiumMembershipCheckAction() {
        return () => {
            void DiscordInstance.getDiscordInstance().sendSDKRequest(SDKRequest.PurchaseMembership, ColonistMembershipType.PremiumMonthly)
        }
    }

    // eslint-disable-next-line class-methods-use-this
    shareImage(title: string, text: string, link: string, imageFile: File, imageSrc: string) {
        void DiscordInstance.getDiscordInstance().sendSDKRequest(SDKRequest.ShareMoment, imageFile)
    }
}
